export function createConnector(createConnectorFn) {
    return createConnectorFn;
}
//# sourceMappingURL=createConnector.js.map